__turbopack_context__.v({
  "chevron": "_8R7Hxq_chevron",
  "content": "_8R7Hxq_content",
  "header": "_8R7Hxq_header",
  "inner": "_8R7Hxq_inner",
  "item": "_8R7Hxq_item",
  "trigger": "_8R7Hxq_trigger",
});
